<template>
  <div class="rate">
    <el-button class="btn-right" type="warning" @click="onOpenDialog">添加分销达人</el-button>
    <el-dialog v-if="dialogVisible" title="添加分销达人" :visible.sync="dialogVisible" modal-append-to-body append-to-body
      @cancel="onCancel">
      <div class="table-tip rate-bottom">第一步：设置推广二维码的分佣比例</div>
      <el-form label-width="150px" :model="form" :rules="rules" ref="form">

        <div class="rate-flex">
          <el-form-item class="rate-left" label="分佣比例" labelWidth="100px" prop="ksDefaultCommRate">
            <el-input :style="{ width: '213px' }" v-model="form.ksDefaultCommRate" placeholder="输入范围：0~8">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <div class="rate-tip">
            <p>1、下方生成推广二维码时将绑定这个分佣比例，您的达人扫码绑定后，<span class="color-red">达人的分佣比例将自动设置成此比例</span> (达人列表可修改分佣比例)。</p>
            <p>2、<span class="color-red">新生成的推广码不影响旧推广码的分佣比例。</span></p>
            <p>3、达人佣金=订单支付价x分佣比例。</p>
            <p>4、<span class="color-red">此比例是您给分销达人的分佣比例，非平台给您的分佣比例。</span></p>
          </div>
        </div>
      </el-form>
      <div class="table-tip rate-bottom">第二步：生成推广二维码，让您的分销达人扫码与您绑定</div>
      <el-button type="warning" :loading="loading" @click="onAddMask">点击生成分享二维码</el-button>
      <!-- 添加达人二维码弹框 -->
      <el-dialog title="分销达人推广二维码" width="860px" :visible.sync="codeVisible" modal-append-to-body append-to-body
        @cancel="onCodeCancel">
        <div class="rate-qrcode">
          <img class="rate-qrcode__img" :src="link" v-if="link" />
          <div class="rate-qrcode__info" v-else>二维码生成失败</div>
          <div class="rate-qrcode__info">
            <div v-if="appName">
              '{{ appName }}'小程序合作码
            </div>
            <div>
              达人分佣比例{{ form.ksDefaultCommRate }}%
            </div>
          </div>

          <div class="rate-qrcode__tip">
            <div>
              1、请把上方专属合作二维码发送给达人，达人使用【快手】扫码，达人同意后即与您绑定合作关系；
            </div>
            <div>
              2、绑定关系的达人直播/发短视频挂载'{{
                appName
              }}'小程序所产生的订单，平台将与您进行结算。
            </div>
          </div>

        </div>

      </el-dialog>

    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
import { matchFractionalPart1 } from "@/utils/regExp";

const DouYinModel = new douYin();
export default {

  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },
    isSet:{
      typeof:[Number,String],
      default:''
    }
  },
  data() {
    return {
      loading: false,
      form: {
        ksDefaultCommRate:"", //快手分佣比例
      },
      appName: "", // 小程序名称
      link: "", // 二维码快手链接
      codeVisible: false, // 弹框显示
      dialogVisible: false, // 显示弹框
      rules: {
        ksDefaultCommRate: [
          {
            required: true,
            message: "请输入分佣比例 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            pattern: matchFractionalPart1,
            message: "请输入数字，最多保留一位小数 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > 8) {
                callback(new Error("请输入0~8之间的数值"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      console.log(this.isSet,'this.isSet==')
      if(this.isSet != 1) {
        this.$message.error('请先设置给达人我的联系方式');
        return
      }
      this.getInfo()
      this.dialogVisible = true;
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 关闭快手码
    onCodeCancel() {
      this.codeVisible = false;
    },

    async getInfo() {
      const data = await DouYinModel.getMasterRelation()
      if (data.data.code !== 200) {
        this.$message.error(data.data.message);
      } else {
        this.form.ksDefaultCommRate = data.data.data.ksDefaultCommRate
        console.log(data.data.data,'data.data.data')
      }
    },
    // 确定
    onAddMask() {
      this.loading = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {

          const data = await DouYinModel.getMasterQrcodeKs({ ...this.form }).finally(() => {
            this.loading = false;
          })
          if (data.data.code !== 200) {
            this.$message.error(data.data.message);
          } else {

            this.link = data.data.data.link;
            this.appName = data.data.data.appName;
            this.codeVisible = true
          }
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 30px 20px 60px 20px;

}

/deep/.el-form {
  .el-input {
    width: 213px;
  }
}


.rate {


  &-left {
    min-width: 350px;
    margin-right: 24px;
    margin-bottom: 0;
  }

  &-flex {
    display: flex;
    margin-bottom: 40px;
    // align-items: center;
  }

  &-tip {
    background: #FAFAFA;
    padding: 8px;
    flex: 1;
  }



  &-bottom {
    margin-bottom: 20px;
  }

  &-code {
    margin-top: 20px;
  }

  &-qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__info {
      margin-top: 20px;
      text-align: center;
      line-height: 24px;

    }

    &__tip {
      margin-top: 30px;
      text-align: left;
      line-height: 24px;
    }

    &__img {
      width: 160px;
      height: 160px;
      object-fit: fill;
      margin: 0 auto;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/distribution/AddMaster.vue